import {Component, Element, h, Method, Prop, Host} from '@stencil/core';

@Component({
    tag: 'nj-infobox-content',
    styleUrl: 'nj-infobox-content.scss',
    shadow: true,
})
export class NjInfoboxContent {

    @Element()
    private element: HTMLElement;

    @Prop({mutable: true})
    isOpen = false;

    @Prop()
    waAriaLabel?: string;

    @Prop()
    label?: string;

    @Method()
    async setOpen(value: boolean) {
        this.isOpen = value;
    }

    @Method()
    async setPosition(x: number, y: number) {
        const content = this.element?.shadowRoot.querySelector('.infobox-content') as HTMLElement
        if (content) {
            content.style.left = x + 'px';
            content.style.top = y + 'px';
            this.fitToViewport();
        }
    }

    componentDidRender() {
        this.fitToViewport();
    }

    private fitToViewport() {
        if (!this.isOpen) {
            return;
        }

        const content = this.element?.shadowRoot.querySelector('.infobox-content') as HTMLElement;
        if (!content) {
            return;
        }

        const rect = content.getBoundingClientRect();
        const overflowLeft = 16 - rect.x;
        const overflowRight = rect.x + rect.width + 16 - window.innerWidth;

        if (overflowLeft > 0) {
            content.style.left = (content.offsetLeft + overflowLeft) + 'px';
        } else if (overflowRight > 0) {
            content.style.left = (content.offsetLeft - overflowRight) + 'px'
        }
    }

    render() {
        return (
            <Host role="region" aria-hidden={!this.isOpen ? 'true' : null } aria-label={this.waAriaLabel ? this.waAriaLabel : null}>
                <div class={this.isOpen ? 'infobox-content infobox-content-open' : 'infobox-content infobox-content-hidden'}>
                    {this.label && <h2 class="infobox-content__title">{this.label}</h2>}
                    <slot/>
                </div>
            </Host>
        );
    }
}
